import { CONSOLE_COLOR_CODE } from '@ricoh/ria.client.core/constants/core/console';
import { loggerStyles } from '@ricoh/ria.client.core/plugins/app/logger';
import { createLogger as createReduxLogger } from 'redux-logger';

/** Redux logger. */
const reduxLogger = createReduxLogger({
  collapsed: true,
  duration: false,
  timestamp: false,
  diff: true,

  level: import.meta.env.APP_LOGGER_LEVEL,

  titleFormatter: (action) => {
    const key = action.type as string;

    const keyText = loggerStyles.colorText(key, CONSOLE_COLOR_CODE.CYAN);
    const flagTextFormat = loggerStyles.colorText(` store `, CONSOLE_COLOR_CODE.WHITE, CONSOLE_COLOR_CODE.BG_LIGHT_BLUE);

    return `${loggerStyles.logLevelText('info')} ${flagTextFormat} ${loggerStyles.responseText('Dispatch')} action ${keyText}`;
  },

  predicate: (_getState, action) => {
    const key = action.type as string;

    // * Exclude component slices
    return !key.startsWith('component_');
  },
});

export default reduxLogger;
